export const baseUrl =  'https://fradi.herokuapp.com/';
// export const baseUrl =  'https://mlsz.herokuapp.com/';
// export const baseUrl = 'http://localhost:8080/';
